enum WorkspaceProjectAiAdviserUserPromptHistoryChatType {
  standards_and_methodologies = 'standards_and_methodologies',
  document_chat = 'document_chat',
}

export default WorkspaceProjectAiAdviserUserPromptHistoryChatType
